export default __webpack_public_path__ + "static/quality_image2-68e01260fc6664e50bd21debd18ff9b1.png";